module.exports = __webpack_public_path__ + "img/img3.c465f064.svg";